module.exports = __webpack_public_path__ + "img/block1Img05.0e917b4d.png";